import React from 'react';
import { withStyles } from '@material-ui/core';
import { formatDateForDisplay } from '../utils';

const styles = (theme: any) => ({
  detailsSection: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 0',
    flexWrap: 'wrap' as const
  },
  detailItem: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 24
  },
  detailLabel: {
    fontSize: 14,
    color: theme.iconColor,
    fontWeight: 500,
    marginRight: 4
  },
  detailValue: {
    fontSize: 14,
    color: theme.TextColor,
    fontWeight: 600
  }
});

interface DetailsSectionProps {
  classes: Record<string, string>;
  rowData: {
    date?: string;
    division?: string;
    region?: string;
    terminalCode?: string;
  } | null;
}

const DetailsSection: React.FC<DetailsSectionProps> = ({ classes, rowData }) => {
  if (!rowData) return null;

  const details = [
    { label: 'Date:', value: formatDateForDisplay(rowData.date) },
    { label: 'Division:', value: rowData.division },
    { label: 'Region:', value: rowData.region },
    { label: 'Terminal:', value: rowData.terminalCode }
  ];

  return (
    <div className={classes.detailsSection}>
      {details.map((detail) => (
        <div key={detail.label} className={classes.detailItem}>
          <span className={classes.detailLabel}>{detail.label}</span>
          <span className={classes.detailValue}>{detail.value || '-'}</span>
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(DetailsSection);
